import { videoTag } from "helpers";
import { sendFluentLog, subtitleLog } from "../../../../../logs";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover } from "redux-share/slices/popoversSlice";
import { setSelectedSubtitle, setSubtitleText } from "redux-share/slices/videoDataSlice";
import ChevronRightIcon from "../../icon-components/chevronRight";
import { shallowEqual } from 'react-redux'

const SubtitlesMenu = ({ setSection }: any) => {

    const dispatch = useAppDispatch();
    const { subtitles, selectedSubtitle } = useAppSelector(({ videoData: { subtitles, selectedSubtitle } }) => ({ subtitles, selectedSubtitle }), shallowEqual);

    return (
        <div id="subtitles" className="animate__animated animate__fadeIn">
            <div className="pl-flex pl-items-center pl-cursor-pointer" onClick={() => setSection("main")}>
                <ChevronRightIcon className="pl-absolute !pl-right-[5px] pl-w-5 pl-h-5 pl-stroke-gray-800 dark:pl-stroke-dark-5" />
                <p className="pl-text-[15px] pl-font-medium pl-py-3 pl-pr-12">انتخاب زیرنویس</p>
            </div>
            <ul className="pl-flex pl-flex-col pl-p-0 pl-m-0">
                <li 
                    className={`pl-flex pl-items-center pl-text-[14px] pl-pr-12 pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 ${!selectedSubtitle && "pl-tick-icon pl-bg-main-light hover:!pl-bg-main-light  pl-text-dark-5"}`}
                    onClick={() => {
                        dispatch(setActiveElements(false));
                        dispatch(setSettingPopover(false));
                        dispatch(setSelectedSubtitle(undefined))
                        setSection("main");
                        const result: any = Object.values(videoTag().textTracks).find((textTrack: any) => textTrack.mode === "showing")
                        if (result) result.mode = "disabled"
                        dispatch(setSubtitleText(""));
                        dispatch(setSelectedSubtitle(undefined));
                        sendFluentLog(subtitleLog("empty"));
                    }}
                >
                    بدون زیرنویس
                </li>
                {subtitles.map((subtitle: any, index: number) => (
                    <li
                        key={index}
                        className={`pl-flex pl-items-center pl-text-[14px] pl-pr-12 pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 ${(selectedSubtitle && selectedSubtitle.language === subtitle.language) && "pl-tick-icon pl-bg-main-light hover:!pl-bg-main-light  pl-text-dark-5"}`}
                        onClick={() => {
                            dispatch(setActiveElements(false));
                            dispatch(setSettingPopover(false));
                            dispatch(setSelectedSubtitle(subtitle))
                            videoTag().textTracks[index].mode = "showing";
                            setSection("main");
                            sendFluentLog(subtitleLog(subtitle.language));
                        }}
                    >
                        <span>{subtitle.label}</span>
                    </li>
                ))}
            </ul>
        </div>
    )
};

export default SubtitlesMenu;